import { render, staticRenderFns } from "./ServiceStatisticsForm.vue?vue&type=template&id=4ce314e8&scoped=true"
import script from "./ServiceStatisticsForm.vue?vue&type=script&lang=js"
export * from "./ServiceStatisticsForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceStatisticsForm.vue?vue&type=style&index=0&id=4ce314e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce314e8",
  null
  
)

export default component.exports